import React, { useState, useEffect, Fragment } from "react";

// MUI
import {
  Typography,
  makeStyles,
  Button,
  TextField,
  Grid,
  Snackbar,
  Avatar,
  FormControl,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useStateValue } from "../store/provider";
import { Alert } from "@material-ui/lab";
import { permissionError } from "../util/alert";
import { updateAdminData, updateAdminProfile } from "../db";
import { storage } from "../firebase/firebase";
import { UPDATE_PROFILE } from "../store/reducer";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    marginTop: "1em",
    width: "80%",
  },
  input: {
    marginTop: "2rem",
  },
  img: {
    border: `3px solid ${theme.palette.primary.main}`,
    width: 150,
    height: 150,
    margin: "auto",
  },
  editButton: {
    position: "absolute",
    right: "0",
    bottom: 0,
  },
  submitButton: {
    margin: "25px 0 0 0",
  },
  profilesection: {
    display: "flex",
    justifyContent: "center",
  },
}));

function Profile(props) {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    image: "",
  });
  const { name, email } = formData;

  const [error, setError] = useState("");
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openProfileSuccess, setOpenProfileSuccess] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [{ admin }, dispatch] = useStateValue();

  useEffect(() => {
    setFormData({
      name: admin.name,
      email: admin.email,
      image: admin.image,
    });
  }, [admin]);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    if (admin.flag) {
      await updateAdminProfile(admin.id, formData);
      dispatch({ type: UPDATE_PROFILE, payload: formData });
      setOpenProfileSuccess(true);
    } else {
      permissionError();
    }
  };

  const handleEditImage = () => {
    document.getElementById("profile-image").click();
  };

  const handleChangeImage = (e) => {
    if (e.target.files[0]) {
      const fileName = new Date().getTime() + e.target.files[0].name;
      const uploadTask = storage
        .ref(`/images/${fileName}`)
        .put(e.target.files[0]);
      uploadTask.on(
        "state_changed",
        () => {},
        (err) => console.log(err),
        async () => {
          const url = await storage
            .ref("images")
            .child(fileName)
            .getDownloadURL();
          setFormData({ ...formData, image: url });
        }
      );
    }
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleChangeConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  const handleCloseError = () => {
    setOpenError(false);
  };

  const handleSubmitChangePassword = async (ev) => {
    ev.preventDefault();
    if (!admin.flag) return permissionError();
    setError("");
    if (password !== confirmPassword) {
      return setError("Password & Confirm Password does not match");
    }
    setLoading(true);
    const res = await updateAdminData(admin.id, { oldPassword, password });
    if (res.error) {
      setOpenError(true);
      setLoading(false);
    }
    setOldPassword("");
    setConfirmPassword("");
    setPassword("");
    setOpenSuccess(true);
    setLoading(false);
  };

  const handleCloseProfileSuccess = () => {
    setOpenProfileSuccess(false);
  };

  return (
    <Grid container alignItems="flex-end">
      <Snackbar
        open={openProfileSuccess}
        autoHideDuration={1000}
        onClose={handleCloseProfileSuccess}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          onClose={handleCloseProfileSuccess}
          severity="success"
        >
          Update successfully.
        </Alert>
      </Snackbar>
      <Grid xs={12} item style={{ textAlign: "center", margin: 20 }}>
        <Typography variant="h5">Profile</Typography>
      </Grid>
      <Grid item lg={8} xs={12} className={classes.profilesection}>
        <form className={classes.form} onSubmit={handleSubmit}>
          <div
            onClick={handleEditImage}
            style={{ position: "relative", cursor: "pointer" }}
          >
            <Avatar
              className={classes.img}
              variant="circle"
              src={formData.image}
            />
            <EditIcon
              style={{
                position: "absolute",
                cursor: "pointer",
                left: "60%",
                top: 0,
              }}
              color="primary"
            />
          </div>
          <input
            name="image"
            id="profile-image"
            type="file"
            hidden="hidden"
            accept="image/*"
            onChange={handleChangeImage}
          />

          <FormControl>
            <TextField
              // focus
              className={classes.input}
              label="Name"
              value={name}
              variant="outlined"
              name="name"
              required
              onChange={onChange}
              type="text"
            />
          </FormControl>
          <FormControl>
            <TextField
              // focus
              value={email}
              className={classes.input}
              label="Email"
              name="email"
              type="email"
              required
              onChange={onChange}
              variant="outlined"
            />
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            className={classes.submitButton}
          >
            Submit
          </Button>
        </form>
      </Grid>
      <Grid item lg={4} xs={12} className={classes.profilesection}>
        <Snackbar
          open={openSuccess}
          autoHideDuration={1000}
          onClose={handleCloseSuccess}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            variant="filled"
            onClose={handleCloseSuccess}
            severity="success"
          >
            Password update successfully.
          </Alert>
        </Snackbar>
        <Snackbar
          open={openError}
          autoHideDuration={3000}
          onClose={handleCloseError}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert variant="filled" onClose={handleCloseError} severity="error">
            Old Password does not match.
          </Alert>
        </Snackbar>

        <form className={classes.form} onSubmit={handleSubmitChangePassword}>
          <Typography variant="h5" color="primary" className={classes.heading}>
            Change Password
          </Typography>
          <TextField
            className={classes.input}
            value={oldPassword}
            variant="outlined"
            onChange={(e) => setOldPassword(e.target.value)}
            color="primary"
            label="Old Password"
            type="password"
            fullWidth
            required
          />
          <TextField
            className={classes.input}
            value={password}
            variant="outlined"
            onChange={handleChangePassword}
            color="primary"
            error={error ? true : false}
            label="New Password"
            type="password"
            fullWidth
            required
          />
          <TextField
            className={classes.input}
            value={confirmPassword}
            variant="outlined"
            error={error ? true : false}
            onChange={handleChangeConfirmPassword}
            color="primary"
            label="Confirm New Password"
            type="password"
            fullWidth
            required
          />
          <Typography
            variant="caption"
            style={{ color: "red", textAlign: "center", margin: 10 }}
          >
            {error}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            required
            disabled={loading}
          >
            Change Password{" "}
            {loading && (
              <CircularProgress style={{ marginLeft: 20 }} size={20} />
            )}
          </Button>
        </form>
      </Grid>
    </Grid>
  );
}

export default React.memo(Profile);
